/**
 * Slice a list for the given 1-indexed page.
 */
export function paginateItems<T>(
  items: readonly T[],
  page: number,
  pageSize: number,
): T[] {
  if (pageSize <= 0) return [...items];
  const safePage = Math.max(1, page);
  const start = (safePage - 1) * pageSize;
  return items.slice(start, start + pageSize);
}

/** Total pages for a collection (minimum 1 when there is at least one item). */
export function getTotalPages(totalItems: number, pageSize: number): number {
  if (totalItems <= 0 || pageSize <= 0) return 0;
  return Math.ceil(totalItems / pageSize);
}

/** Clamp a 1-indexed page to `[1, totalPages]` (or 1 when `totalPages` is 0). */
export function clampPage(page: number, totalPages: number): number {
  if (totalPages <= 0) return 1;
  return Math.min(Math.max(1, page), totalPages);
}

/** Parse `?page=N` from Next.js search params (defaults to 1). */
export function parsePageParam(value: string | string[] | undefined): number {
  const raw = Array.isArray(value) ? value[0] : value;
  if (!raw) return 1;
  const parsed = Number.parseInt(raw, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
}
